import React, { useState } from "react";
import NumberFormat from "react-number-format";
import food from "../../../assets/img/food-img.svg";
import pet from "../../../assets/img/pet-img.svg";
import moda from "../../../assets/img/moda-img.svg";
import farmacia from "../../../assets/img/farmacia-img.svg";
import lazer from "../../../assets/img/lazer-img.svg";
import beleza from "../../../assets/img/beleza-img.svg";
import orderImg from "../../../assets/img/arrow-order.svg";
import filledStar from "../../../assets/img/filledStar.svg";
import outlineStar from "../../../assets/img/outlineStar.svg";
import empty_establishment from "../../../assets/img/empty_establishment.svg";
import ReactStars from "react-rating-stars-component";
import { isFloat } from "../../../config/utils";

export function WidgetBig(props) {
  return (
    <div
      className={`card col-12 col-lg px-0 ${
        (props.className !== undefined) & (props.className !== null) ? props.className : ""
      }`}
    >
      {props.children}
    </div>
  );
}

export function WidgetTabs(props) {
  const [isActive, setIsActive] = useState(props.categories[0]);
  let total = 0;
  for (const item of props.list) {
    if (item.category === isActive) {
      total = total + item.qt;
    }
  }
  return (
    <>
      <div className={`tabs ${(props.className !== undefined) & (props.className !== null) ? props.className : ""}`}>
        <label className="mt-3 ms-4 fz-16 ff-univanova-600 text-cl-black">{props.title}</label>
        <div className="d-flex justify-content-center mt-2">
          {props.categories.map((type) => (
            <button
              onClick={() => setIsActive(type)}
              className={`mx-3 mx-lg-3 fz-16 ff-univanova-600 ${isActive === type ? "active" : "inactive"}`}
            >
              {type}
            </button>
          ))}
        </div>
        <div className="list w-100">
          {props.list
            .filter((x) => x.category === isActive)
            .map((item, index) => (
              <WidgetListItem className={index % 2 === 0 ? "" : "bg-cl-cultured"} name={item.name} qt={item.qt} />
            ))}
        </div>
      </div>
      <WidgetListTotal name={"Total"} qt={total} />
    </>
  );
}

function WidgetListItem(props) {
  return (
    <div
      className={`px-4 py-3 d-flex align-items-center ${
        (props.className !== undefined) & (props.className !== null) ? props.className : ""
      }`}
    >
      <div className="col-10">
        <label className="fz-14 ff-univanova-regular text-cl-black">{props.name}</label>
      </div>
      <div className="col-2 d-flex justify-content-end">
        <NumberFormat
          className="fz-14 ff-univanova-regular text-cl-black"
          thousandSeparator={"."}
          decimalSeparator=""
          displayType={"text"}
          prefix={props.qt < 10 ? "0" : ""}
          value={props.qt}
        />
      </div>
    </div>
  );
}

function WidgetListTotal(props) {
  return (
    <div
      className={`px-4 py-3 d-flex align-items-center  ${
        (props.className !== undefined) & (props.className !== null) ? props.className : ""
      }`}
    >
      <div className="col-10">
        <label className="fz-14 ff-univanova-600 text-cl-black">{props.name}</label>
      </div>
      <div className="col-2 d-flex justify-content-end">
        <NumberFormat
          className="fz-14 ff-univanova-600 text-cl-black "
          thousandSeparator={"."}
          decimalSeparator=""
          displayType={"text"}
          prefix={props.qt < 10 ? "0" : ""}
          value={props.qt}
        />
      </div>
    </div>
  );
}

export function WidgetByCategory(props) {
  function imgSelect(value) {
    let object = {
      food: food,
      moda: moda,
      pet: pet,
      lazer: lazer,
      beleza: beleza,
      farmacia: farmacia,
    };
    return object[value];
  }
  return (
    <>
      <div
        className={`category ${(props.className !== undefined) & (props.className !== null) ? props.className : ""}`}
      >
        <label className="mt-3 ms-4 fz-16 ff-univanova-600 text-cl-black">{props.title}</label>
        <div className="list w-100 mt-2 pb-3">
          {props.list?.map((item, index) => (
            <WidgetListItemImage
              className={index % 2 === 0 ? "" : "bg-cl-cultured h-100"}
              img={imgSelect(item.img)}
              name={item.name}
              qt={item.qt}
            />
          ))}
        </div>
      </div>
    </>
  );
}

function WidgetListItemImage(props) {
  return (
    <div
      className={`px-4 py-3 d-flex align-items-center ${
        (props.className !== undefined) & (props.className !== null) ? props.className : ""
      }`}
    >
      <div className="col-10">
        <img className="rounded" alt="" src={props.img} height={48} />
        <label className="fz-14 ff-univanova-regular text-cl-black ms-2">{props.name}</label>
      </div>
      <div className="col-2 d-flex justify-content-end">
        <NumberFormat
          className="fz-14 ff-univanova-regular text-cl-black"
          thousandSeparator={"."}
          decimalSeparator=""
          displayType={"text"}
          prefix={props.qt < 10 ? "0" : ""}
          value={props.qt}
        />
      </div>
    </div>
  );
}

export function WidgetwithRatingOrder(props) {
  const [clicked, setClicked] = useState(false);
  function order(a, b) {
    if (clicked === false) {
      if (a.rate < b.rate) {
        return -1;
      }
      if (a.rate > b.rate) {
        return 1;
      }
      return 0;
    } else {
      if (a.rate < b.rate) {
        return 1;
      }
      if (a.rate > b.rate) {
        return -1;
      }
      return 0;
    }
  }

  let ordernar = () => {
    setClicked(!clicked);
    props.list.sort(order);
  };
  return (
    <>
      <div className={`rating ${(props.className !== undefined) & (props.className !== null) ? props.className : ""}`}>
        <label className="mt-3 ms-4 fz-16 ff-univanova-600 text-cl-black">
          {props.title}
          <img alt="" src={orderImg} className="c-pointer" onClick={() => ordernar()} />
        </label>
        <div className="list w-100 mt-2 pb-3">
          {props.list.length ? (
            <>
              {props.list.map((item, index) => (
                <WidgetRatingListItem
                  className={index % 2 === 0 ? "" : "bg-cl-cultured h-100"}
                  img={item.establishmentPhoto[0]?.url ? item.establishmentPhoto[0]?.url : empty_establishment}
                  name={item.storeName}
                  qt={item.rate}
                />
              ))}
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
}

function WidgetRatingListItem(props) {
  let options = {
    count: 5,
    value: props.qt,
    edit: false,
    isHalf: false,
    emptyIcon: <img alt="" width={12} height={12} src={outlineStar} />,
    filledIcon: <img alt="" width={12} height={12} src={filledStar} />,
  };
  return (
    <div
      className={`px-3 px-lg-3 py-3 d-flex align-items-center ${
        (props.className !== undefined) & (props.className !== null) ? props.className : ""
      }`}
    >
      <div className="col-lg-7 d-flex justify-content-start align-items-center">
        <img className="logo me-2 col-8" alt="" src={props.img} />
        <label className="fz-14 ff-univanova-regular col-8 text-cl-black">{props.name}</label>
      </div>
      <div className="col-lg-5 d-flex justify-content-end align-items-center">
        <ReactStars {...options} />
        <NumberFormat
          className="fz-14 ff-univanova-regular text-cl-black ms-2"
          thousandSeparator={"."}
          decimalSeparator=""
          displayType={"text"}
          suffix={isFloat(props.qt) === false ? ",0" : ""}
          prefix={""}
          value={props.qt}
        />
      </div>
    </div>
  );
}
